export default "__VITE_ASSET__Dngbp4R8__"